import { Section, SectionHeader } from '../components/ui/Section'
import { Button } from '../components/ui/Button'

const workAreas = [
  {
    title: 'Governed Human–Agent Collaboration',
    description: 'Practical systems in which people set intent and boundaries, agents perform bounded work, and consequential results are reviewed, verified, and corrected.',
  },
  {
    title: 'Useful Technology',
    description: 'Software and automation designed around a real human job: reducing friction, making information more available, and leaving accountability with people.',
  },
  {
    title: 'Healthcare & Support Tools',
    description: 'Clinician-informed tools for healthcare workflows, grief, grounding, and clearer decisions—with explicit privacy, safety, and non-clinical boundaries.',
  },
  {
    title: 'Structural Ethics',
    description: 'Governance, incentives, permissions, and audit trails that make responsible behavior part of how a system works—not an aspiration added afterward.',
  },
  {
    title: 'Venture & Practice Labs',
    description: 'Small, testable collaborations that combine underused skills around real work, real customers, paid participation, and measurable learning.',
  },
  {
    title: 'Existential Math & E1',
    description: 'A philosophical research program beginning with ∃ 1—at minimum, there is this—and exploring one existence expressed through many perspectives. Each added premise is named; the framework remains provisional.',
  },
]

export function HomePage() {
  return (
    <>
      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-b from-slate-50 to-white">
        <div className="container-wide py-24 md:py-36">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight">
              Build useful things. Keep people in the loop.
            </h1>
            <p className="mt-8 text-xl text-slate-600 leading-relaxed">
              Sum1 Solutions builds from a simple recognition: beneath our
              different histories and perspectives, human beings encounter
              many of the same fears, feelings, needs, and possibilities. We
              develop technology, research, and practical ventures that help
              those perspectives work together without erasing their
              differences—finding solutions together that none of us may find
              alone.
            </p>
            <p className="mt-6 text-lg text-slate-500 leading-relaxed">
              Founded by a physician and software builder. Human intent,
              bounded agent work, explicit uncertainty, and verifiable results.
            </p>
            <div className="mt-12 flex flex-wrap gap-4">
              <Button href="/contact" size="lg">
                Get in Touch
              </Button>
              <Button href="/about" variant="outline" size="lg">
                About
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Work Areas */}
      <Section className="bg-white">
        <SectionHeader
          title="What We Work On"
          subtitle="Research becomes useful when it survives contact with real work."
        />
        <div className="grid md:grid-cols-2 gap-8">
          {workAreas.map((area) => (
            <div key={area.title} className="p-8 bg-slate-50 rounded-xl">
              <h3 className="text-xl font-semibold text-slate-900 mb-4">{area.title}</h3>
              <p className="text-slate-600 leading-relaxed">{area.description}</p>
            </div>
          ))}
        </div>
      </Section>

      {/* Contact CTA */}
      <Section className="bg-slate-900 text-white">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8">Let's Talk</h2>
          <p className="text-lg text-slate-300 mb-10 leading-relaxed">
            Have a concrete problem, an underused capability, or a project that
            needs more than one kind of knowing? Bring your voice. Let’s find
            what becomes possible when the choir can hear itself.
          </p>
          <Button href="/contact" variant="inverse">
            Contact Us
          </Button>
        </div>
      </Section>
    </>
  )
}
